// EC Tuning Garage - Musical Instruments, Tuning Gear & Studio Audio
// Brand: EC Capital Investments LLC
// Inspired by theonlinetuningmarket.com (musical instruments marketplace)

// ============================================
// SITE IMAGES - Musical Instruments / Tuning Theme
// ============================================
export const siteImages = {
  heroMain: 'https://images.unsplash.com/photo-1727383196205-7205669078f7?q=80&w=2670&auto=format&fit=crop',
  heroSecondary: 'https://images.unsplash.com/photo-1595002435321-133ac0aee0bc?q=80&w=2670&auto=format&fit=crop',
  heroLifestyle: 'https://images.unsplash.com/photo-1511735111819-9a3f7709049c?q=80&w=2670&auto=format&fit=crop',
  ctaBackground: 'https://images.unsplash.com/photo-1514320291840-2e0a9bf2a9ae?q=80&w=2670&auto=format&fit=crop',
  featuredBackground: 'https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?q=80&w=2670&auto=format&fit=crop',
  powerBackground: 'https://images.unsplash.com/photo-1519681393784-d120267933ba?q=80&w=2670&auto=format&fit=crop',
  shopBanner: 'https://images.unsplash.com/photo-1465821185615-20b3c2fbf41b?q=80&w=2670&auto=format&fit=crop',
  aboutBanner: 'https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?q=80&w=2670&auto=format&fit=crop',
  contactBanner: 'https://images.unsplash.com/photo-1485579149621-3123dd979885?q=80&w=2670&auto=format&fit=crop',
  returnsBanner: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?q=80&w=2670&auto=format&fit=crop',
  privacyBanner: 'https://images.unsplash.com/photo-1514320291840-2e0a9bf2a9ae?q=80&w=2670&auto=format&fit=crop',
};

export const SHIPPING_NOTICE = 'We ship within the USA via USPS';
export const SHIPPING_COUNTRIES = ['US'];
export const SHIPPING_METHOD = 'USPS';
export const SHIPPING_TIME = '2-4 business days';
export const FREE_SHIPPING_THRESHOLD = 0; // Free shipping on all orders

export const CARD_DESCRIPTOR = '8556067903ectuninggara';
export const HOSTING_PROVIDER = 'Hostinger';

export const CONTACT_INFO = {
  phone: '(855) 606-7903',
  email: 'contactus@ectuninggarage.com',
  corpName: 'EC Capital Investments LLC',
  address: {
    street: '2212 N Sibley St',
    city: 'Metairie',
    state: 'LA',
    zip: '70003',
    country: 'United States'
  }
};

export const RETURN_ADDRESS = {
  street: '4711 34th St. N. Suite F',
  city: 'St. Petersburg',
  state: 'FL',
  zip: '33714',
  country: 'USA'
};

// ============================================
// MUSICAL INSTRUMENTS PRODUCT CATALOG
// ============================================
// Specific prices applied to nearest products:
// $9.63, $12.84, $19.26, $19.37, $28.89, $58.11, $77.48,
// $142.16, $227.48, $318.72, $489.36, $612.44, $784.88, $999.00

export const products = [
  // ===== DRUMS & PERCUSSION =====
  {
    id: "drumstick-bag",
    name: "Drumstick Bag",
    slug: "drumstick-bag",
    sku: "MS-DRM-001",
    price: 9.63,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HSVDKMSE7JD5B6TEAX5M2NNS.webp",
    badge: "Deal",
    categoryId: "drums-percussion",
    categorySlug: "drums-percussion",
    description: "Spacious Storage: Boasting a generous 24mm depth, this drumstick bag offers ample room to keep all your sticks, brushes and mallets organized for every gig and rehearsal.",
    keyBenefits: ["Spacious 24mm interior depth", "Durable nylon construction", "Convenient strap & hook"],
    usage: "Carry your drumsticks, brushes and mallets to every rehearsal, lesson and gig.",
    features: ["Roomy Interior", "Heavy-Duty Zipper", "Carry Strap", "Stage-Ready"],
    inStock: true
  },
  {
    id: "digital-electronic-drum-pad",
    name: "Digital Electronic Drum Pad",
    slug: "digital-electronic-drum-pad",
    sku: "MS-DRM-002",
    price: 12.84,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HRYYG6AKCGM2HXJYYT2729YG.webp",
    badge: "Best Seller",
    categoryId: "drums-percussion",
    categorySlug: "drums-percussion",
    description: "High-Quality Construction: Crafted from premium ABS plastic, this drum pad ensures durable, responsive performance for practice sessions anywhere.",
    keyBenefits: ["Premium ABS construction", "Responsive playing surface", "Whisper-quiet practice"],
    usage: "Practice rudiments and grooves silently at home, in apartments or backstage.",
    features: ["ABS Build", "Quiet Surface", "Portable", "Practice-Ready"],
    inStock: true
  },
  {
    id: "drum-pad",
    name: "Silent Drum Practice Pad",
    slug: "drum-pad",
    sku: "MS-DRM-003",
    price: 19.37,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HTQHPD80G4XN98PJG5T38GPX.jpg",
    categoryId: "drums-percussion",
    categorySlug: "drums-percussion",
    description: "Hone Your Drumming Skills Anytime, Anywhere with Our Silent Drum Practice Pad — designed for stick control, rebound and quiet rehearsal.",
    keyBenefits: ["Silent practice surface", "Natural stick rebound", "Compact, take-anywhere size"],
    usage: "Place on a flat surface and run rudiments, paradiddles and chops without disturbing neighbors.",
    features: ["Natural Rebound", "Silent Play", "Stand Compatible", "Compact"],
    inStock: true
  },
  {
    id: "portable-somatosensory-drum-kit",
    name: "Portable Somatosensory Drum Kit Electronic Drumsticks",
    slug: "portable-somatosensory-drum-kit",
    sku: "MS-DRM-004",
    price: 77.48,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HRZ0A63WHFNHNFB9JK5WCYA4.webp",
    badge: "Innovative",
    categoryId: "drums-percussion",
    categorySlug: "drums-percussion",
    description: "Introducing Body Feel Drum, a revolutionary drum simulation experience that redefines portable practice. Air-drum anywhere with motion-sensing electronic drumsticks.",
    keyBenefits: ["Motion-sensing drumsticks", "10+ realistic drum kit sounds", "Built-in speaker & headphone jack"],
    usage: "Wave the sticks in the air to trigger snare, kick, toms, hi-hat and cymbals — practice or perform anywhere.",
    features: ["Motion Sensors", "10+ Kits", "Built-in Speaker", "Portable"],
    inStock: true
  },
  {
    id: "portable-steel-tongue-drum-kit",
    name: "Portable Steel Tongue Drum Kit",
    slug: "portable-steel-tongue-drum-kit",
    sku: "MS-DRM-005",
    price: 142.16,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01J01MNV0Z4SXQMZY5JS0TSDV5.jpg",
    badge: "Handpan",
    categoryId: "drums-percussion",
    categorySlug: "drums-percussion",
    description: "Unleash your musical creativity with our Portable Steel Tongue Drum Kit, perfect for meditation, music therapy and on-the-go performance.",
    keyBenefits: ["Hand-tuned harmonic tongues", "Travel bag & mallets included", "Beginner to pro friendly"],
    usage: "Play with mallets or fingers — perfect for meditation, sound therapy and ambient music.",
    features: ["Hand-Tuned", "Travel Bag", "Mallets Included", "Steel Build"],
    inStock: true
  },
  {
    id: "precision-kick-bass-drum-pedal",
    name: "Precision Kick Bass Drum Pedal",
    slug: "precision-kick-bass-drum-pedal",
    sku: "MS-DRM-006",
    price: 142.16,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HYGHZWCQCJNVCNJTQ6KK19JG.jpg",
    badge: "Pro Pedal",
    categoryId: "drums-percussion",
    categorySlug: "drums-percussion",
    description: "Elevate your drumming with the Precision Kick Bass Drum Pedal, designed for both studio recording and live performance with smooth chain-drive action.",
    keyBenefits: ["Smooth chain-drive action", "Adjustable beater angle & spring tension", "Heavy-duty steel baseplate"],
    usage: "Bolt onto your bass drum hoop and dial in your action. Built for rock, metal, jazz and beyond.",
    features: ["Chain-Drive", "Adjustable Beater", "Steel Baseplate", "Studio & Stage"],
    inStock: true
  },
  {
    id: "steel-drum",
    name: "Handpan Steel Drum Set",
    slug: "steel-drum",
    sku: "MS-DRM-007",
    price: 227.48,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HVS59B36Y83NG726PH15FQQE.jpg",
    badge: "Tongue Drum",
    categoryId: "drums-percussion",
    categorySlug: "drums-percussion",
    description: "Step into the serene soundscape with this enchanting Handpan Steel Drum Set. Each tongue is hand-tuned to deliver a warm, resonant tone.",
    keyBenefits: ["Hand-tuned for warm resonance", "Sustained, meditative tones", "Carrying case included"],
    usage: "Play seated with the drum on your lap. Use mallets or hands for percussive grooves and melodic phrases.",
    features: ["Hand-Tuned", "Resonant", "Carry Case", "Mallets Included"],
    inStock: true
  },
  {
    id: "professional-concert-snare-drum",
    name: "Professional Concert Snare Drum",
    slug: "professional-concert-snare-drum",
    sku: "MS-DRM-008",
    price: 489.36,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01J01NHPF07XDJJBX9J0Q0M7M3.jpg",
    badge: "Pro",
    categoryId: "drums-percussion",
    categorySlug: "drums-percussion",
    description: "Elevate your percussion performance with our Professional Concert Snare Drum. Designed for orchestral, marching and recording use with a crisp articulate response.",
    keyBenefits: ["Maple shell with crisp articulation", "Premium 20-strand snare wires", "Symphonic-grade hardware"],
    usage: "Concert, orchestra, marching band, studio and live percussion — built to perform at the highest level.",
    features: ["Maple Shell", "20-Strand Wires", "Pro Hardware", "Concert-Grade"],
    inStock: true
  },
  {
    id: "professional-acoustic-drum-kit",
    name: "Professional 5-Piece Acoustic Drum Kit",
    slug: "professional-acoustic-drum-kit",
    sku: "MS-DRM-009",
    price: 784.88,
    image: "https://images.unsplash.com/photo-1519892300165-cb5542fb47c7?q=80&w=1200&auto=format&fit=crop",
    badge: "Flagship",
    categoryId: "drums-percussion",
    categorySlug: "drums-percussion",
    description: "Studio-grade 5-piece acoustic drum kit featuring 100% maple shells, double-braced hardware, cymbal pack and a deep, rich tone built for stage and studio.",
    keyBenefits: ["100% maple shells for warm projection", "Double-braced hardware throughout", "Includes cymbals, throne & pedal"],
    usage: "Set up in your studio, garage or stage. Configurable as classic 5-piece for any genre.",
    features: ["Maple Shells", "Cymbal Pack", "Double-Braced", "Complete Kit"],
    inStock: true
  },

  // ===== GUITARS & TUNERS =====
  {
    id: "6pcs-guitar-locking-tuners",
    name: "6pcs Guitar Locking Tuners",
    slug: "6pcs-guitar-locking-tuners",
    sku: "MS-GTR-001",
    price: 19.26,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HTN3NZGA68EZEJ6Y64CYW65Q.jpg",
    badge: "Tuning",
    categoryId: "guitars-tuners",
    categorySlug: "guitars-tuners",
    description: "Elevate Your Guitar's Tuning Stability with Our Set of 6 High-Precision Guitar Tuning Pegs - A Harmonious Blend of Style and Functionality. Universal compatibility for most electric and acoustic guitars.",
    keyBenefits: ["Locking design holds tune longer", "Sealed gears for smooth tuning", "Universal compatibility"],
    usage: "Swap onto your guitar headstock for rock-solid tuning stability. Ideal for studio and stage players.",
    features: ["Locking Pegs", "Sealed Gears", "6-Piece Set", "Universal Fit"],
    inStock: true
  },
  {
    id: "pocket-guitar-neck-trainer",
    name: "Pocket Guitar Neck Trainer for Right-Hand Use",
    slug: "pocket-guitar-neck-trainer",
    sku: "MS-GTR-002",
    price: 77.48,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HYGPTV3B147XS78YAW4HK3VV.jpg",
    badge: "Travel",
    categoryId: "guitars-tuners",
    categorySlug: "guitars-tuners",
    description: "Master your guitar skills on the go with the Portable Pocket Guitar Neck Trainer. Real strings and fretboard in a pocket-sized package.",
    keyBenefits: ["Pocket-sized practice fretboard", "Real strings & frets", "Build finger strength anywhere"],
    usage: "Slip into your bag for commute practice, airport delays or quiet warm-ups before a gig.",
    features: ["Real Strings", "Pocket Size", "Right-Hand", "Portable"],
    inStock: true
  },
  {
    id: "all-in-one-acoustic-electric-guitar-starter-set",
    name: "All-In-One Acoustic Electric Guitar Starter Set",
    slug: "all-in-one-acoustic-electric-guitar-starter-set",
    sku: "MS-GTR-003",
    price: 612.44,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HYGN30XJ53ERAYB83SK1VXK7.jpg",
    badge: "Starter Set",
    categoryId: "guitars-tuners",
    categorySlug: "guitars-tuners",
    description: "Embark on your musical journey with the All-In-One Acoustic Electric Guitar Starter Set. Everything you need — guitar, tuner, picks, strap, capo, gig bag — to start playing.",
    keyBenefits: ["Complete acoustic/electric guitar bundle", "Includes gig bag, tuner, strap & picks", "Onboard preamp for plug-in performance"],
    usage: "Pick up, plug in to any amplifier or P.A., or play unplugged. Perfect for beginners and gigging musicians.",
    features: ["Acoustic/Electric", "Full Accessories Bundle", "Onboard Preamp", "Gig Bag Included"],
    inStock: true
  },
  {
    id: "premium-concert-grand-piano",
    name: "Premium Concert Grand Piano",
    slug: "premium-concert-grand-piano",
    sku: "MS-KEY-001",
    price: 999.00,
    image: "https://images.unsplash.com/photo-1520523839897-bd0b52f945a0?q=80&w=1200&auto=format&fit=crop",
    badge: "Flagship",
    categoryId: "guitars-tuners",
    categorySlug: "guitars-tuners",
    description: "Reference-grade premium concert grand piano with 88 weighted keys, hammer-action mechanism, multi-sampled grand piano voices and full pedal unit. The flagship of our instrument lineup.",
    keyBenefits: ["88 graded hammer-action keys", "Multi-sampled grand piano voices", "Full 3-pedal unit included"],
    usage: "Studio, recital hall and home concert use. Pair with monitors or headphones for late-night sessions.",
    features: ["88 Keys", "Hammer Action", "Multi-Sampled", "3-Pedal Unit"],
    inStock: true
  },

  // ===== STRING INSTRUMENTS =====
  {
    id: "viola",
    name: "Full-Size Viola",
    slug: "viola",
    sku: "MS-STR-001",
    price: 142.16,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HVS2D44R28SH88NFQ54BMFKD.jpg",
    badge: "String",
    categoryId: "string-instruments",
    categorySlug: "string-instruments",
    description: "Step into the rich mid-range of the string family with this full-size viola. Built for students, teachers and chamber players who want a warm, balanced tone.",
    keyBenefits: ["Hand-carved spruce top", "Warm balanced viola tone", "Comes with bow, case & rosin"],
    usage: "Solo, chamber and orchestra players. Comes ready to tune and play out of the case.",
    features: ["Spruce Top", "Bow & Case", "Rosin Included", "Full Size"],
    inStock: true
  },
  {
    id: "handcrafted-16-string-mahogany-lyre-harp",
    name: "Handcrafted 16-String Mahogany Lyre Harp",
    slug: "handcrafted-16-string-mahogany-lyre-harp",
    sku: "MS-STR-002",
    price: 77.48,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HXHV6DJ607KXKHYWJP4CEG7Z.jpg",
    badge: "Handcrafted",
    categoryId: "string-instruments",
    categorySlug: "string-instruments",
    description: "Discover the enchanting sound of this 16-string lyre harp, meticulously shaped from solid mahogany and finished with care for ethereal acoustic resonance.",
    keyBenefits: ["Solid mahogany body", "Pure, ethereal resonance", "16 metal strings included"],
    usage: "Rest on your lap or a table and pluck the strings — perfect for meditation, soundtracks and folk music.",
    features: ["Mahogany Body", "16 Strings", "Tuning Wrench", "Hand-Finished"],
    inStock: true
  },
  {
    id: "heritage-carved-wooden-cello-holder",
    name: "Heritage Carved Wooden Cello Holder",
    slug: "heritage-carved-wooden-cello-holder",
    sku: "MS-STR-003",
    price: 58.11,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HYGJQ1F3KNM6Q84YFVF3JJ27.jpg",
    badge: "Display",
    categoryId: "string-instruments",
    categorySlug: "string-instruments",
    description: "Display your cello with pride using this beautifully carved wooden stand. Crafted from solid hardwood with intricate detailing — both functional storage and elegant home decor.",
    keyBenefits: ["Hand-carved solid hardwood", "Stable cello-friendly cradle", "Doubles as room decor"],
    usage: "Place in a corner of your studio, living room or rehearsal space. Cradle and neck rest protect your instrument.",
    features: ["Solid Hardwood", "Hand-Carved", "Stable Base", "Heritage Design"],
    inStock: true
  },

  // ===== WOODWIND & BRASS =====
  {
    id: "clarinet",
    name: "Maestro Clarinet",
    slug: "clarinet",
    sku: "MS-WND-001",
    price: 142.16,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HVS1A08ZEYQWHCQFQ8PHP86D.jpg",
    badge: "Woodwind",
    categoryId: "woodwind-brass",
    categorySlug: "woodwind-brass",
    description: "Unleash the sweet symphony of woodwinds with this exquisitely crafted Maestro Clarinet. B-flat tuning, nickel-plated keys and warm tonal character.",
    keyBenefits: ["B-flat tuning, student-to-pro ready", "Nickel-plated keys", "Includes case, reeds & cleaning kit"],
    usage: "Concert band, jazz ensembles and solo performance. Ready to play out of the box.",
    features: ["B-Flat Tuning", "Nickel Keys", "Case & Reeds", "Cleaning Kit"],
    inStock: true
  },
  {
    id: "trio-of-soprano-clarinet-recorders",
    name: "Trio of Soprano Clarinet Recorders",
    slug: "trio-of-soprano-clarinet-recorders",
    sku: "MS-WND-002",
    price: 77.48,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HXHVSTGW569H7CY20TF4VCXZ.jpg",
    badge: "Set of 3",
    categoryId: "woodwind-brass",
    categorySlug: "woodwind-brass",
    description: "A versatile set of three soprano recorders designed for students, educators and ensemble use. Bright, clear tone and easy fingering for beginners.",
    keyBenefits: ["Set of 3 matched recorders", "Clear bright soprano tone", "Ideal for classrooms and ensembles"],
    usage: "Music teachers, students and recorder consorts. Each recorder includes a cleaning rod and bag.",
    features: ["3-Recorder Set", "Cleaning Rods", "Soprano Tuning", "Beginner-Friendly"],
    inStock: true
  },
  {
    id: "elite-concert-flute-in-silver",
    name: "Elite Concert Flute in Silver",
    slug: "elite-concert-flute-in-silver",
    sku: "MS-WND-003",
    price: 318.72,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HYGQ67H5FVT6E1SBD86D3JWS.jpg",
    badge: "Concert",
    categoryId: "woodwind-brass",
    categorySlug: "woodwind-brass",
    description: "Experience the exceptional clarity and responsiveness with the Elite Concert Flute in Silver. Designed for serious students, advancing players and professional concert performance.",
    keyBenefits: ["Silver-plated body and headjoint", "Closed-hole offset G", "Responsive concert-grade tone"],
    usage: "Concert band, wind ensemble, orchestra and solo recital — built to project in any room.",
    features: ["Silver Plated", "Closed-Hole", "Offset G", "Hardshell Case"],
    inStock: true
  },
  {
    id: "mini-digital-saxophone",
    name: "Mini Digital Saxophone",
    slug: "mini-digital-saxophone",
    sku: "MS-WND-004",
    price: 142.16,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HVS2VSXW7N6JFW46VCYJCQ9C.jpg",
    badge: "Digital",
    categoryId: "woodwind-brass",
    categorySlug: "woodwind-brass",
    description: "Experience the expressiveness of a saxophone in a pocket-friendly digital format. Built-in voices, headphone output and rechargeable battery let you practice anywhere.",
    keyBenefits: ["Authentic sax voices built in", "Headphone jack for silent practice", "Pocket-sized & rechargeable"],
    usage: "Practice anywhere with headphones. Great for travel, students and saxophonists keeping their chops up.",
    features: ["Built-in Voices", "Headphone Out", "Rechargeable", "Pocket-Sized"],
    inStock: true
  },
  {
    id: "swan-7-piece-diatonic-harmonica-set",
    name: "Swan 7-Piece Diatonic Harmonica Set",
    slug: "swan-7-piece-diatonic-harmonica-set",
    sku: "MS-WND-005",
    price: 58.11,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01J01K8XR8D30HSZW37Y63W165.jpg",
    badge: "Set of 7",
    categoryId: "woodwind-brass",
    categorySlug: "woodwind-brass",
    description: "Cover every major key with this comprehensive seven-harmonica collection from Swan. Each harmonica is tuned to a different key for instant playability in any song.",
    keyBenefits: ["7 harmonicas covering major keys", "Brass reeds for warm tone", "Hardshell carry case included"],
    usage: "Pick a harmonica by key to match any song. Perfect for blues, folk, country and pro touring musicians.",
    features: ["7 Major Keys", "Brass Reeds", "Carry Case", "Hardshell"],
    inStock: true
  },

  // ===== STUDIO AUDIO & CABLES =====
  {
    id: "mini-sound-mixer",
    name: "Mini Sound Mixer",
    slug: "mini-sound-mixer",
    sku: "MS-AUD-001",
    price: 28.89,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HVRYSHTBX8914KF6FMBDCMDK.jpg",
    badge: "Studio",
    categoryId: "studio-audio",
    categorySlug: "studio-audio",
    description: "Transform your streaming, podcasting, or gaming experience with the Mini Sound Mixer. Compact 4-channel mixer with effects, EQ and USB output.",
    keyBenefits: ["Compact 4-channel mixer", "Built-in effects & EQ", "USB output for streaming"],
    usage: "Podcasters, streamers and home musicians. Connect mics and instruments, send to your DAW via USB.",
    features: ["4 Channels", "EQ & FX", "USB Output", "Compact"],
    inStock: true
  },
  {
    id: "premium-hifi-speaker-cable-set",
    name: "Premium HiFi Speaker Cable Set",
    slug: "premium-hifi-speaker-cable-set",
    sku: "MS-AUD-002",
    price: 58.11,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HXHX20E8QCK5913F9TZGA6EG.jpg",
    badge: "HiFi",
    categoryId: "studio-audio",
    categorySlug: "studio-audio",
    description: "Enhance your audio experience with our Premium HiFi Speaker Cable Set, designed for studio monitors and high-end home theater. Oxygen-free copper with gold-plated banana plugs.",
    keyBenefits: ["Oxygen-free copper conductors", "Gold-plated banana plugs", "Studio and home-theater ready"],
    usage: "Run between amplifier and speakers in your studio or hi-fi setup for maximum signal integrity.",
    features: ["OFC Copper", "Gold Plated", "Banana Plugs", "Hi-Fi Grade"],
    inStock: true
  },
  {
    id: "wood-color-record-player",
    name: "Wood Color Record Player Turntable",
    slug: "wood-color-record-player",
    sku: "MS-AUD-003",
    price: 58.11,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HSVM944C82XB675M6SF83JHH.webp",
    badge: "Retro",
    categoryId: "studio-audio",
    categorySlug: "studio-audio",
    description: "Bring warm analog sound into your space with this retro-styled turntable in a natural wood finish. Built-in speakers, 3-speed playback and Bluetooth output.",
    keyBenefits: ["Built-in stereo speakers", "3-speed playback (33/45/78)", "Bluetooth output for headphones"],
    usage: "Spin vinyl on the shelf or coffee table. Stream to wireless speakers via the built-in Bluetooth.",
    features: ["3-Speed", "Built-in Speakers", "Bluetooth Out", "Wood Finish"],
    inStock: true
  },
  {
    id: "elite-audiophile-rca-cable",
    name: "Elite Audiophile RCA Cable",
    slug: "elite-audiophile-rca-cable",
    sku: "MS-AUD-004",
    price: 318.72,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HXHX8E9A4AMTCV410ZTZMRR8.jpg",
    badge: "Audiophile",
    categoryId: "studio-audio",
    categorySlug: "studio-audio",
    description: "Our Elite Audiophile RCA Cable is specifically designed for high-end audio systems and reference studios. Silver-plated copper, double-shielded with locking connectors.",
    keyBenefits: ["Silver-plated copper signal path", "Double-shielded against EMI/RFI", "Locking RCA connectors"],
    usage: "Connect turntables, DACs and pre-amps with reference-grade interconnects.",
    features: ["Silver Plated", "Double Shielded", "Locking RCA", "Reference Grade"],
    inStock: true
  },

  // ===== INSTRUMENT ACCESSORIES (Recorder care, cases, stands, bags) =====
  {
    id: "bass-recorder-oil-brush",
    name: "Bass Recorder Oil Brush by Moeck",
    slug: "bass-recorder-oil-brush",
    sku: "MS-ACC-001",
    price: 13.99,
    image: "https://earlymusicshop.com/cdn/shop/products/MOEZ0025_72f416b1-cce9-4b4b-8f65-4988f6b30a6a_240x400.jpg",
    badge: "Care",
    categoryId: "instrument-accessories",
    categorySlug: "instrument-accessories",
    description: "Oil brush (horsehair and metal stick) for bass recorder by Moeck. Designed to apply recorder oil precisely along the bore of your wooden bass recorder.",
    keyBenefits: ["Horsehair tip for smooth oil application", "Metal stick handle for full bore reach", "Made for bass recorder"],
    usage: "Dip in recorder oil and run gently through the bore of your bass recorder during routine maintenance.",
    features: ["Horsehair", "Metal Stick", "Bass Recorder", "Made in Germany"],
    inStock: true
  },
  {
    id: "maintenance-kit-sopranino-soprano",
    name: "Maintenance Kit for Sopranino/Soprano Recorder by Moeck",
    slug: "maintenance-kit-sopranino-soprano",
    sku: "MS-ACC-002",
    price: 33.00,
    image: "https://earlymusicshop.com/cdn/shop/products/MOEZ0001_240x400.jpg",
    badge: "Kit",
    categoryId: "instrument-accessories",
    categorySlug: "instrument-accessories",
    description: "Everything you need to keep your sopranino or soprano recorder in the best possible condition in a smart, compact kit. Contains recorder oil, oil brush, anti-condensant and cleaning rod.",
    keyBenefits: ["Complete care kit in compact pouch", "Includes oil, anti-condensant & brush", "Made by Moeck of Germany"],
    usage: "Use periodically to oil the bore, dispel condensation and clean the inside of your sopranino or soprano recorder.",
    features: ["Recorder Oil", "Oil Brush", "Anti-Condensant", "Cleaning Rod"],
    inStock: true
  },
  {
    id: "bass-recorder-neck-sling-kung",
    name: "Bass / Great Bass Recorder Neck Sling by Kung",
    slug: "bass-recorder-neck-sling-kung",
    sku: "MS-ACC-003",
    price: 39.00,
    image: "https://earlymusicshop.com/cdn/shop/products/9015_Tragriemen_512x322.jpg",
    badge: "Support",
    categoryId: "instrument-accessories",
    categorySlug: "instrument-accessories",
    description: "Deluxe neck sling by Kung that comfortably supports a bass or great bass recorder during long rehearsals and performances. Padded for comfort with secure hook attachment.",
    keyBenefits: ["Padded neck strap for long sessions", "Secure hook for bass / great bass recorders", "Built by Kung of Switzerland"],
    usage: "Loop around the neck and clip onto the recorder thumb-rest hook to relieve weight on hands and wrists.",
    features: ["Padded", "Secure Hook", "Bass / Great Bass", "Kung Swiss-Made"],
    inStock: true
  },
  {
    id: "baroque-violin-mute-alter",
    name: "Baroque Violin Mute by Alter",
    slug: "baroque-violin-mute-alter",
    sku: "MS-ACC-004",
    price: 43.00,
    image: "https://earlymusicshop.com/cdn/shop/products/GetAttachmentThumbnail-1_512x492.jpg",
    badge: "Baroque",
    categoryId: "instrument-accessories",
    categorySlug: "instrument-accessories",
    description: "A new sound world emerges when the mute slides on — an Alter mute sounds special, not just quieter. Players rave about the unique tonal colour these handmade mutes bring to baroque violin.",
    keyBenefits: ["Hand-made baroque violin mute", "Unique warm muted tone", "Slides on/off in seconds"],
    usage: "Slide onto the bridge of your baroque violin for a softer, characterful sound in chamber and home practice.",
    features: ["Hand-Made", "Baroque Violin", "Slide-On", "Warm Tone"],
    inStock: true
  },
  {
    id: "recorder-cleaning-rod-cloth-set",
    name: "Recorder Cleaning Rod & Cloth Set by Moeck",
    slug: "recorder-cleaning-rod-cloth-set",
    sku: "MS-ACC-005",
    price: 44.00,
    image: "https://earlymusicshop.com/cdn/shop/products/MOEZ0023_512x66.jpg",
    badge: "Care Set",
    categoryId: "instrument-accessories",
    categorySlug: "instrument-accessories",
    description: "Set of wooden cleaning rods with cleaning cloths for sopranino, soprano, alto and tenor recorders. Essential for keeping the bore clear of moisture after every play session.",
    keyBenefits: ["Set of cleaning rods for multiple sizes", "Soft cloth swabs included", "Made by Moeck of Germany"],
    usage: "Wrap the cloth around the rod and pass through the bore of the recorder after each playing session.",
    features: ["Multiple Sizes", "Cleaning Cloths", "Wooden Rods", "Moeck Quality"],
    inStock: true
  },
  {
    id: "maintenance-kit-alto-tenor",
    name: "Maintenance Kit for Alto / Tenor Recorder by Moeck",
    slug: "maintenance-kit-alto-tenor",
    sku: "MS-ACC-006",
    price: 48.75,
    image: "https://earlymusicshop.com/cdn/shop/products/MOEZ0001_b15bd023-ba9e-46ed-8364-f85350008353_240x400.jpg",
    badge: "Kit",
    categoryId: "instrument-accessories",
    categorySlug: "instrument-accessories",
    description: "Everything you need to keep your alto or tenor recorder in best condition in a smart, compact kit. Contains recorder oil, oil brush, anti-condensant and cleaning rod with cloth.",
    keyBenefits: ["Complete alto/tenor care kit", "Compact carry pouch", "Made by Moeck of Germany"],
    usage: "Use periodically to oil the bore, dispel condensation and clean the inside of your alto or tenor recorder.",
    features: ["Oil", "Brush", "Anti-Condensant", "Cleaning Rod"],
    inStock: true
  },
  {
    id: "cork-grease-care-bundle",
    name: "Recorder Cork Grease & Care Bundle by Moeck",
    slug: "cork-grease-care-bundle",
    sku: "MS-ACC-007",
    price: 49.00,
    image: "https://earlymusicshop.com/cdn/shop/products/MOEZ0005_240x400.jpg",
    badge: "Bundle",
    categoryId: "instrument-accessories",
    categorySlug: "instrument-accessories",
    description: "Cork grease bundle by Moeck — enables smooth assembling and dismantling of your recorder, protects the cork from damage and ensures a snug, wind- and moisture-tight joint.",
    keyBenefits: ["Smooth assembly & disassembly", "Protects recorder cork joints", "Wind- and moisture-tight seal"],
    usage: "Apply a small amount to each cork joint before assembling your recorder to prevent dryness and wear.",
    features: ["Cork Grease", "Protective", "Easy Apply", "Moeck Made"],
    inStock: true
  },
  {
    id: "recorder-anticondensant-twin-pack",
    name: "Recorder Anti-Condensant Twin Pack by Moeck",
    slug: "recorder-anticondensant-twin-pack",
    sku: "MS-ACC-008",
    price: 50.00,
    image: "https://earlymusicshop.com/cdn/shop/products/MOEZ0004_240x400.jpg",
    badge: "Twin Pack",
    categoryId: "instrument-accessories",
    categorySlug: "instrument-accessories",
    description: "Twin pack of Moeck anti-condensant. Effective in preventing the hoarseness caused by condensation that blocks the windway, ensuring a consistently clean and pure sound.",
    keyBenefits: ["Prevents windway blockage", "Keeps sound clean and pure", "Two-bottle value pack"],
    usage: "Apply a few drops to the windway of your recorder before playing to keep it free of condensation.",
    features: ["Twin Pack", "Windway Care", "Pure Tone", "Long-Lasting"],
    inStock: true
  },
  {
    id: "soprano-recorder-soft-pouch",
    name: "Soprano Recorder Soft Padded Pouch by EMS",
    slug: "soprano-recorder-soft-pouch",
    sku: "MS-ACC-009",
    price: 55.00,
    image: "https://earlymusicshop.com/cdn/shop/products/DSC06354_512x304.png",
    badge: "Travel",
    categoryId: "instrument-accessories",
    categorySlug: "instrument-accessories",
    description: "Soft padded pouch for soprano recorder with fleece-lined interior and black canvas exterior. A lightweight, gig-bag-style alternative to a hard case.",
    keyBenefits: ["Fleece-lined interior", "Tough black canvas exterior", "Lightweight gig-bag design"],
    usage: "Slip your soprano recorder inside and toss into any backpack or larger case for safe transit.",
    features: ["Fleece Lined", "Canvas", "Soprano Size", "Lightweight"],
    inStock: true
  },
  {
    id: "soprano-recorder-hard-case-kung",
    name: "Soprano Recorder Hard Case by Kung",
    slug: "soprano-recorder-hard-case-kung",
    sku: "MS-ACC-010",
    price: 56.25,
    image: "https://earlymusicshop.com/cdn/shop/products/9302.1_Etui_Superio_Sopran_512x322.jpg",
    badge: "Hard Case",
    categoryId: "instrument-accessories",
    categorySlug: "instrument-accessories",
    description: "A compact, hard recorder case by Kung for soprano recorder, with grey canvas and light tan leather trim. Smart, durable and travel-friendly.",
    keyBenefits: ["Rigid hard-shell protection", "Grey canvas & leather trim", "Kung Swiss-Made"],
    usage: "Store your soprano recorder safely at home, in the classroom or while travelling between rehearsals.",
    features: ["Hard Shell", "Canvas/Leather", "Soprano Size", "Kung Quality"],
    inStock: true
  },
  {
    id: "ems-3-slot-recorder-roll-bag",
    name: "EMS 3-Slot Fleece Lined Recorder Roll Bag",
    slug: "ems-3-slot-recorder-roll-bag",
    sku: "MS-ACC-011",
    price: 57.00,
    image: "https://earlymusicshop.com/cdn/shop/products/DSC06354_512x304.png",
    badge: "Roll Bag",
    categoryId: "instrument-accessories",
    categorySlug: "instrument-accessories",
    description: "EMS 3-slot fleece-lined recorder roll bag with black canvas exterior. A very competitively priced roll bag that accommodates a soprano and alto together with one extra slot.",
    keyBenefits: ["Three padded slots", "Fleece-lined interior", "Black canvas exterior"],
    usage: "Roll up your soprano, alto and extra recorder together for safe transit to lesson, rehearsal or gig.",
    features: ["3 Slots", "Fleece Lined", "Canvas", "Roll-Up Design"],
    inStock: true
  },
  {
    id: "alto-recorder-hard-case-kung",
    name: "Alto Recorder Hard Case by Kung",
    slug: "alto-recorder-hard-case-kung",
    sku: "MS-ACC-012",
    price: 58.00,
    image: "https://earlymusicshop.com/cdn/shop/products/9302.1_Etui_Superio_Sopran_512x322.jpg",
    badge: "Hard Case",
    categoryId: "instrument-accessories",
    categorySlug: "instrument-accessories",
    description: "A compact, hard recorder case by Kung for alto recorder, with grey canvas and light tan leather trim. Smart, durable and travel-friendly.",
    keyBenefits: ["Rigid hard-shell protection", "Grey canvas & leather trim", "Kung Swiss-Made"],
    usage: "Store your alto recorder safely at home, in the classroom or while travelling between rehearsals.",
    features: ["Hard Shell", "Canvas/Leather", "Alto Size", "Kung Quality"],
    inStock: true
  },
  {
    id: "tenor-recorder-hard-case-kung",
    name: "Tenor Recorder Hard Case by Kung",
    slug: "tenor-recorder-hard-case-kung",
    sku: "MS-ACC-013",
    price: 60.00,
    image: "https://earlymusicshop.com/cdn/shop/products/9302.1_Etui_Superio_Sopran_512x322.jpg",
    badge: "Hard Case",
    categoryId: "instrument-accessories",
    categorySlug: "instrument-accessories",
    description: "A compact, hard recorder case by Kung sized for tenor recorder, with grey canvas and light tan leather trim. Durable protection for your investment.",
    keyBenefits: ["Rigid hard-shell protection", "Grey canvas & leather trim", "Kung Swiss-Made"],
    usage: "Store your tenor recorder safely at home, in the classroom or while travelling between rehearsals.",
    features: ["Hard Shell", "Canvas/Leather", "Tenor Size", "Kung Quality"],
    inStock: true
  },
  {
    id: "recorder-cross-stand-5",
    name: "Recorder Cross Stand (for 5 recorders) by The Early Music Shop",
    slug: "recorder-cross-stand-5",
    sku: "MS-ACC-014",
    price: 65.00,
    image: "https://earlymusicshop.com/cdn/shop/files/EMSRSX01_512x342.jpg",
    badge: "Stand",
    categoryId: "instrument-accessories",
    categorySlug: "instrument-accessories",
    description: "Our recorder cross stand for five recorders, available exclusively at The Early Music Shop. A robust yet light-weight recorder stand with a clever cross design.",
    keyBenefits: ["Holds 5 recorders securely", "Robust yet lightweight", "Easy assembly"],
    usage: "Place beside your music stand to keep your full set of recorders within easy reach during a consort session.",
    features: ["5 Slots", "Cross Design", "Lightweight", "Stable Base"],
    inStock: true
  },
  {
    id: "recorder-consort-stand-6",
    name: "Recorder Consort Stand (for 6 recorders) by EMS",
    slug: "recorder-consort-stand-6",
    sku: "MS-ACC-015",
    price: 70.00,
    image: "https://earlymusicshop.com/cdn/shop/products/Recorderstand_512x769.jpg",
    badge: "Stand",
    categoryId: "instrument-accessories",
    categorySlug: "instrument-accessories",
    description: "Our recorder consort stand for six recorders, available exclusively at The Early Music Shop. A robust yet light-weight stand for consort players.",
    keyBenefits: ["Holds 6 recorders securely", "Robust and light-weight", "Compact footprint"],
    usage: "Park your consort beside your chair to grab the right size recorder instantly during ensemble work.",
    features: ["6 Slots", "Consort", "Lightweight", "Stable Base"],
    inStock: true
  },
  {
    id: "compact-3-slot-padded-bag",
    name: "Compact 3-Slot Padded Recorder Carrying Bag",
    slug: "compact-3-slot-padded-bag",
    sku: "MS-ACC-016",
    price: 75.00,
    image: "https://earlymusicshop.com/cdn/shop/products/DSC06354_512x304.png",
    badge: "Travel",
    categoryId: "instrument-accessories",
    categorySlug: "instrument-accessories",
    description: "Compact 3-slot padded carrying bag for soprano, alto and tenor recorders. Fleece-lined inside, durable canvas outside, with comfortable carry handle and shoulder strap.",
    keyBenefits: ["Padded fleece-lined interior", "3 sized recorder slots", "Carry handle & shoulder strap"],
    usage: "Take your S/A/T recorder trio to lessons, gigs and rehearsals with full protection.",
    features: ["3 Slots", "Fleece Lined", "Shoulder Strap", "Padded"],
    inStock: true
  },
  {
    id: "padded-4-slot-recorder-bag",
    name: "Padded 4-Slot Recorder Carrying Bag by EMS",
    slug: "padded-4-slot-recorder-bag",
    sku: "MS-ACC-017",
    price: 78.00,
    image: "https://earlymusicshop.com/cdn/shop/products/1_512x309.jpg",
    badge: "Travel",
    categoryId: "instrument-accessories",
    categorySlug: "instrument-accessories",
    description: "Four-slot padded carrying bag for a full sopranino-to-tenor recorder set. Fleece-lined inside, tough canvas exterior, with reinforced bottom and music pocket.",
    keyBenefits: ["4 padded slots", "Music sheet pocket", "Tough canvas exterior"],
    usage: "Carry your whole consort set plus sheet music to teaching dates and group rehearsals.",
    features: ["4 Slots", "Music Pocket", "Reinforced", "Padded"],
    inStock: true
  },
  {
    id: "ems-5-slot-recorder-roll-bag",
    name: "EMS 5-Slot Fleece Lined Recorder Roll Bag",
    slug: "ems-5-slot-recorder-roll-bag",
    sku: "MS-ACC-018",
    price: 80.00,
    image: "https://earlymusicshop.com/cdn/shop/products/1_512x309.jpg",
    badge: "Roll Bag",
    categoryId: "instrument-accessories",
    categorySlug: "instrument-accessories",
    description: "EMS 5-slot fleece-lined recorder roll bag with black canvas exterior. A very competitively priced roll bag that accommodates a full sopranino-to-tenor set plus an extra slot.",
    keyBenefits: ["Five padded slots", "Fleece-lined interior", "Black canvas exterior"],
    usage: "Roll up to five recorders together for safe transport to consort rehearsals.",
    features: ["5 Slots", "Fleece Lined", "Canvas", "Roll-Up"],
    inStock: true
  },
  {
    id: "ems-6-slot-recorder-roll-bag",
    name: "EMS 6-Slot Fleece Lined Recorder Roll Bag",
    slug: "ems-6-slot-recorder-roll-bag",
    sku: "MS-ACC-019",
    price: 85.00,
    image: "https://earlymusicshop.com/cdn/shop/products/1_512x309.jpg",
    badge: "Roll Bag",
    categoryId: "instrument-accessories",
    categorySlug: "instrument-accessories",
    description: "EMS 6-slot fleece-lined recorder roll bag with black canvas exterior. A very competitively priced roll bag that accommodates soprano, alto and tenor recorders plus three more slots.",
    keyBenefits: ["Six padded slots", "Fleece-lined interior", "Black canvas exterior"],
    usage: "Carry your entire recorder consort plus spares in a single, lightweight roll bag.",
    features: ["6 Slots", "Fleece Lined", "Canvas", "Roll-Up"],
    inStock: true
  },
  {
    id: "stand-4-recorders-kung",
    name: "Stand for 4 Recorders by Kung",
    slug: "stand-4-recorders-kung",
    sku: "MS-ACC-020",
    price: 90.00,
    image: "https://earlymusicshop.com/cdn/shop/products/9025.2_2er_Staender_512x322.jpg",
    badge: "Stand",
    categoryId: "instrument-accessories",
    categorySlug: "instrument-accessories",
    description: "Attractive stand for 4 recorders by Kung. This will cater for different combinations of recorders from sopranino to tenor with smart Swiss craftsmanship.",
    keyBenefits: ["Holds 4 recorders securely", "Swiss-made Kung quality", "Compact footprint"],
    usage: "Keep your four working recorders at hand throughout long teaching and practice sessions.",
    features: ["4 Slots", "Swiss-Made", "Kung", "Stable"],
    inStock: true
  },
  {
    id: "stand-3-recorders-kung",
    name: "Stand for 3 Recorders by Kung",
    slug: "stand-3-recorders-kung",
    sku: "MS-ACC-021",
    price: 93.00,
    image: "https://earlymusicshop.com/cdn/shop/products/9025.2_2er_Staender_512x322.jpg",
    badge: "Stand",
    categoryId: "instrument-accessories",
    categorySlug: "instrument-accessories",
    description: "Attractive stand for 3 recorders by Kung. This will cater for different combinations of recorders from sopranino to tenor with smart Swiss craftsmanship.",
    keyBenefits: ["Holds 3 recorders securely", "Swiss-made Kung quality", "Compact footprint"],
    usage: "Park three working recorders at hand for trio rehearsals or daily practice.",
    features: ["3 Slots", "Swiss-Made", "Kung", "Stable"],
    inStock: true
  },
  {
    id: "ems-recorder-care-travel-kit",
    name: "EMS Premium Recorder Care Travel Kit",
    slug: "ems-recorder-care-travel-kit",
    sku: "MS-ACC-022",
    price: 99.00,
    image: "https://earlymusicshop.com/cdn/shop/products/MOEZ0001_b15bd023-ba9e-46ed-8364-f85350008353_240x400.jpg",
    badge: "Premium",
    categoryId: "instrument-accessories",
    categorySlug: "instrument-accessories",
    description: "Premium recorder care travel kit bundled by The Early Music Shop. Includes recorder oil, anti-condensant, cork grease, cleaning rods and brushes in a smart zippered case.",
    keyBenefits: ["Full premium care suite", "All sizes covered", "Smart zippered travel case"],
    usage: "Throw in your gig bag and you are covered for every maintenance task on tour or in the classroom.",
    features: ["Full Kit", "All Sizes", "Zippered Case", "Travel-Ready"],
    inStock: true
  },
  {
    id: "padded-7-slot-recorder-bag",
    name: "Padded 7-Slot Recorder Carrying Bag by EMS",
    slug: "padded-7-slot-recorder-bag",
    sku: "MS-ACC-023",
    price: 100.00,
    image: "https://earlymusicshop.com/cdn/shop/products/DSC06358_512x309.png",
    badge: "Travel",
    categoryId: "instrument-accessories",
    categorySlug: "instrument-accessories",
    description: "Seven-slot padded recorder carrying bag from The Early Music Shop. Fleece-lined inside, durable canvas outside, with carry handle, shoulder strap and music sheet pocket.",
    keyBenefits: ["7 padded slots", "Carry handle & shoulder strap", "Music sheet pocket"],
    usage: "Carry a full consort plus spares to ensemble rehearsals and teaching dates.",
    features: ["7 Slots", "Fleece Lined", "Strap", "Music Pocket"],
    inStock: true
  },
  {
    id: "stand-5-recorders-kung",
    name: "Stand for 5 Recorders by Kung",
    slug: "stand-5-recorders-kung",
    sku: "MS-ACC-024",
    price: 101.00,
    image: "https://earlymusicshop.com/cdn/shop/products/KUN9055_512x253.jpg",
    badge: "Stand",
    categoryId: "instrument-accessories",
    categorySlug: "instrument-accessories",
    description: "Attractive stand for 5 recorders by Kung. This will cater for different combinations of recorders from sopranino to tenor with smart Swiss craftsmanship and a stable footprint.",
    keyBenefits: ["Holds 5 recorders securely", "Swiss-made Kung quality", "Stable footprint"],
    usage: "Park your sopranino-to-tenor consort at hand for fast switching in rehearsals and lessons.",
    features: ["5 Slots", "Swiss-Made", "Kung", "Stable"],
    inStock: true
  },
  {
    id: "ems-9-slot-recorder-roll-bag",
    name: "EMS 9-Slot Fleece Lined Recorder Roll Bag",
    slug: "ems-9-slot-recorder-roll-bag",
    sku: "MS-ACC-025",
    price: 105.00,
    image: "https://earlymusicshop.com/cdn/shop/products/DSC06358_512x309.png",
    badge: "Roll Bag",
    categoryId: "instrument-accessories",
    categorySlug: "instrument-accessories",
    description: "EMS 9-slot fleece-lined recorder roll bag with black canvas exterior. A very competitively priced roll bag that accommodates a large consort set with plenty of room.",
    keyBenefits: ["Nine padded slots", "Fleece-lined interior", "Black canvas exterior"],
    usage: "Roll up to nine recorders together for safe transport to consort rehearsals and teaching gigs.",
    features: ["9 Slots", "Fleece Lined", "Canvas", "Roll-Up"],
    inStock: true
  },
  {
    id: "ems-ur10-padded-bag",
    name: "EMS UR10 'Un-Roll' Padded 10-Slot Recorder Carrying Bag",
    slug: "ems-ur10-padded-bag",
    sku: "MS-ACC-026",
    price: 110.00,
    image: "https://earlymusicshop.com/cdn/shop/products/EMSUR10_500x667.JPG",
    badge: "Pro",
    categoryId: "instrument-accessories",
    categorySlug: "instrument-accessories",
    description: "The EMS 'Un-Roll 10' case is a very popular bag which combines the lightness of roll bags with the capacity and protection of a hard-style case. 10 padded slots.",
    keyBenefits: ["10 padded recorder slots", "Combines roll bag lightness with hard case protection", "Backpack-style straps"],
    usage: "Carry an entire teaching consort comfortably as a backpack between schools, halls and venues.",
    features: ["10 Slots", "Backpack Straps", "Padded", "Pro Grade"],
    inStock: true
  },
  {
    id: "premium-12-slot-recorder-bag",
    name: "Premium 12-Slot Recorder Carrying Bag by EMS",
    slug: "premium-12-slot-recorder-bag",
    sku: "MS-ACC-027",
    price: 125.00,
    image: "https://earlymusicshop.com/cdn/shop/products/EMSUR10_500x667.JPG",
    badge: "Premium",
    categoryId: "instrument-accessories",
    categorySlug: "instrument-accessories",
    description: "Premium 12-slot recorder carrying bag from The Early Music Shop. Fleece-lined inside, heavy-duty canvas outside, with backpack straps and a generous music pocket.",
    keyBenefits: ["12 padded slots", "Heavy-duty canvas exterior", "Backpack straps & music pocket"],
    usage: "Take a full teaching or workshop kit anywhere — sopranino, soprano, alto, tenor and spares included.",
    features: ["12 Slots", "Heavy-Duty", "Backpack Straps", "Music Pocket"],
    inStock: true
  },
  {
    id: "ems-3-slot-bass-recorder-bag",
    name: "EMS 3-Slot Bass Recorder Fleece Lined Roll Bag",
    slug: "ems-3-slot-bass-recorder-bag",
    sku: "MS-ACC-028",
    price: 140.00,
    image: "https://earlymusicshop.com/cdn/shop/products/DSC06362_512x512.png",
    badge: "Bass",
    categoryId: "instrument-accessories",
    categorySlug: "instrument-accessories",
    description: "EMS 3 slot bass recorder fleece-lined roll bag, black canvas exterior. A larger roll bag with three generous slots sized to take a bass recorder.",
    keyBenefits: ["Three bass-sized slots", "Fleece-lined for protection", "Tough black canvas exterior"],
    usage: "Roll up a bass recorder plus tenors safely for transit to consort rehearsals.",
    features: ["3 Bass Slots", "Fleece Lined", "Canvas", "Heavy-Duty"],
    inStock: true
  },
  {
    id: "tenor-recorder-padded-carrying-bag",
    name: "Tenor Recorder Padded Carrying Bag by EMS",
    slug: "tenor-recorder-padded-carrying-bag",
    sku: "MS-ACC-029",
    price: 150.00,
    image: "https://earlymusicshop.com/cdn/shop/products/EMSUR10_500x667.JPG",
    badge: "Travel",
    categoryId: "instrument-accessories",
    categorySlug: "instrument-accessories",
    description: "Heavy-duty padded carrying bag tailored for a tenor recorder plus accessories. Deeply padded with reinforced bottom and backpack straps for comfortable touring.",
    keyBenefits: ["Deep tenor-size padding", "Reinforced bottom", "Backpack-style straps"],
    usage: "Protect your tenor recorder when commuting between practice rooms, concerts and workshops.",
    features: ["Tenor Size", "Reinforced", "Backpack Straps", "Padded"],
    inStock: true
  },
  {
    id: "ems-deluxe-lute-soft-case",
    name: "EMS Deluxe Lute Soft Padded Case",
    slug: "ems-deluxe-lute-soft-case",
    sku: "MS-ACC-030",
    price: 170.00,
    image: "https://earlymusicshop.com/cdn/shop/products/IMG_3725_512x384.jpg",
    badge: "Deluxe",
    categoryId: "instrument-accessories",
    categorySlug: "instrument-accessories",
    description: "EMS Deluxe Lute Soft Padded Case — a soft case with thick padding, strap and accessory pocket, suitable for most lutes up to 8 courses. Lightweight protection for daily transit.",
    keyBenefits: ["Thick soft padding", "Accessory pocket", "Adjustable shoulder strap"],
    usage: "Carry your lute to lessons, recitals and rehearsals with everyday protection.",
    features: ["Soft Padded", "Shoulder Strap", "Accessory Pocket", "Lute"],
    inStock: true
  },
  {
    id: "paetzold-soft-bag-great-bass",
    name: "Paetzold Soft Carrying Bag for Great Bass Recorder",
    slug: "paetzold-soft-bag-great-bass",
    sku: "MS-ACC-031",
    price: 195.00,
    image: "https://earlymusicshop.com/cdn/shop/products/PAE45T_512x294.jpg",
    badge: "Pro",
    categoryId: "instrument-accessories",
    categorySlug: "instrument-accessories",
    description: "Highly recommended for travel and storage of your Paetzold great bass recorder. Lightweight construction with exterior pocket for music. Cordura exterior, velvet-style interior.",
    keyBenefits: ["Cordura outer, velvet-feel interior", "Lightweight design", "Exterior music pocket"],
    usage: "Travel safely with your Paetzold great bass recorder between rehearsals, recordings and concerts.",
    features: ["Cordura", "Music Pocket", "Great Bass Size", "Lightweight"],
    inStock: true
  },
];

// ============================================
// CATEGORIES
// ============================================
export const categories = [
  {
    id: "drums-percussion",
    name: "Drums & Percussion",
    slug: "drums-percussion",
    description: "Acoustic drum kits, electronic pads, handpans and pro percussion gear for every drummer",
    image: "https://novagen.s3.us-east-2.amazonaws.com/01J01NHPF07XDJJBX9J0Q0M7M3.jpg",
    productCount: 9
  },
  {
    id: "guitars-tuners",
    name: "Guitars & Tuners",
    slug: "guitars-tuners",
    description: "Acoustic and electric guitars, locking tuners, starter sets and keyboard flagships",
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HYGN30XJ53ERAYB83SK1VXK7.jpg",
    productCount: 4
  },
  {
    id: "string-instruments",
    name: "String Instruments",
    slug: "string-instruments",
    description: "Violas, lyre harps and heritage carved string instrument stands",
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HVS2D44R28SH88NFQ54BMFKD.jpg",
    productCount: 3
  },
  {
    id: "woodwind-brass",
    name: "Woodwind & Brass",
    slug: "woodwind-brass",
    description: "Clarinets, concert flutes, saxophones, recorders and pro harmonicas",
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HVS1A08ZEYQWHCQFQ8PHP86D.jpg",
    productCount: 5
  },
  {
    id: "studio-audio",
    name: "Studio Audio & Cables",
    slug: "studio-audio",
    description: "Sound mixers, audiophile cables, turntables and pro studio audio gear",
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HVRYSHTBX8914KF6FMBDCMDK.jpg",
    productCount: 4
  },
  {
    id: "instrument-accessories",
    name: "Instrument Accessories",
    slug: "instrument-accessories",
    description: "Recorder care kits, hard cases, padded roll bags, consort stands, bows and pro early-music accessories",
    image: "https://earlymusicshop.com/cdn/shop/products/EMSUR10_500x667.JPG",
    productCount: 31
  },
];

// ============================================
// FEATURES / WHY CHOOSE US
// ============================================
export const features = [
  { id: 1, title: 'Curated Instruments', description: 'Hand-picked musical instruments and tuning gear, tested by working musicians' },
  { id: 2, title: 'Free USA Shipping', description: 'Free USPS Standard Shipping on every order' },
  { id: 3, title: '30-Day Returns', description: 'Easy returns within 30 days, no hassle' },
  { id: 4, title: 'Secure Checkout', description: 'Encrypted payments and protected customer data' }
];

export const performanceBenefits = [
  { id: 1, title: 'Craftsmanship', description: 'Superior craftsmanship from trusted instrument makers' },
  { id: 2, title: 'Professional-Grade', description: 'Instruments and gear musicians actually use on stage and in studio' },
  { id: 3, title: 'Reliable Tuning', description: 'Tuning pegs, mics and cables built to stay rock-solid' },
  { id: 4, title: 'Affordable Pricing', description: 'Honest prices for beginners through to working pros' }
];

export const steps = [
  { id: 1, title: 'Browse', description: 'Explore our curated lineup of premium musical instruments and tuning gear.' },
  { id: 2, title: 'Pick', description: 'Choose the instrument, accessory or studio gear that fits your sound.' },
  { id: 3, title: 'Checkout', description: 'Complete your order with secure, encrypted payment.' },
  { id: 4, title: 'Play', description: 'Unbox, tune up and make beautiful music.' }
];
